import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadPlans, deletePlan} from '../../../../../state/modules/plans/actions';
import {sendMessage} from '../../../../../state/actions';
import PlansList from '../components/PlansList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.plans.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['plans', x]),
              schema.plan,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.plans.get('isLoading'),
    total: state.plans.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadPlans(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deletePlan(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const PlansListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlansList);

export default PlansListContainer;
